import { render, staticRenderFns } from "./FloatingBanner.vue?vue&type=template&id=b2ac0cb4&scoped=true&"
import script from "./FloatingBanner.vue?vue&type=script&lang=js&"
export * from "./FloatingBanner.vue?vue&type=script&lang=js&"
import style0 from "./FloatingBanner.vue?vue&type=style&index=0&id=b2ac0cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ac0cb4",
  null
  
)

export default component.exports